export const dieselLocomotiveIds = ["4081", "4394", "4396", "4398"];

export const isBusLikeRouteType = (routeType) => {
  const type = Number(routeType);
  return type === 3 || (type >= 700 && type < 800);
};

export const getFerryDisplayName = (vehicle) =>
  vehicle?.vehicle_label ||
  vehicle?.registration_number ||
  vehicle?.fleet_number ||
  "Ferry";

export const getTrainDisplayName = (vehicle, fallbackIdentifier) => {
  const trainLabel =
    vehicle?.vehicle_label ||
    vehicle?.fleet_number ||
    vehicle?.vehicle_id ||
    fallbackIdentifier;

  return trainLabel ? `Train ${trainLabel}` : "Train";
};

export const shouldShowElectricTransportIcon = (
  routeType,
  identifier,
  vehicle,
) => {
  const type = Number(routeType);

  if (type === 2) {
    if (vehicle?.is_electric != null) {
      return Boolean(vehicle.is_electric);
    }

    return !dieselLocomotiveIds.includes(identifier);
  }

  if (type === 4) {
    return Boolean(vehicle?.is_electric);
  }

  return Boolean(vehicle?.is_electric);
};

export const shouldShowDoubleDeckerIcon = (vehicle) =>
  vehicle?.decks === "Double";

export const formatVehicleIdentity = (vehicle, fallbackIdentifier) => {
  if (vehicle?.vehicle_type === "ferry") {
    return getFerryDisplayName(vehicle);
  }

  const fleetNumber = vehicle?.fleet_number
    ? String(vehicle.fleet_number).trim()
    : "";
  const registrationNumber = vehicle?.registration_number
    ? String(vehicle.registration_number).trim()
    : "";
  const vehicleId = vehicle?.vehicle_id ? String(vehicle.vehicle_id).trim() : "";
  const visibleFleetNumber =
    fleetNumber ||
    (registrationNumber && vehicleId && vehicleId !== registrationNumber
      ? vehicleId
      : "");

  if (
    visibleFleetNumber &&
    registrationNumber &&
    visibleFleetNumber !== registrationNumber
  ) {
    return `Bus ${visibleFleetNumber} / ${registrationNumber}`;
  }

  if (visibleFleetNumber) {
    return `Bus ${visibleFleetNumber}`;
  }

  if (registrationNumber) {
    return `Bus ${registrationNumber}`;
  }

  if (vehicleId) {
    return `Bus ${vehicleId}`;
  }

  if (fallbackIdentifier) {
    return `Bus ${fallbackIdentifier}`;
  }

  return "Bus";
};

export const getTransportLabel = (routeType, identifier, vehicle) => {
  switch (Number(routeType)) {
    case 2:
      return getTrainDisplayName(vehicle, identifier);
    case 4:
      return getFerryDisplayName(vehicle);
    case 5:
      return "Cable Car";
    default:
      return formatVehicleIdentity(vehicle, identifier);
  }
};
